<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./modal.scss";
</style>

<template>
  <div>
    <div v-if="modalVisible" class="slk-g-modal-backdrop"></div>
    <div :class="`slk-g-modal slk-mdl-v-${variant} ${type}`" v-if="modalVisible && isScreenSizeAboveBreakpoint">
      <header>
        <div class="close">
          <svg class="icon feather" @click="closeModal">
            <use :href="`/imgs/storybook/feather-sprite.svg#x`" />
          </svg>
        </div>
        <div class="title-block">
          <div class="modal-icon" v-if="hasIcon">
            <svg class="icon feather">
              <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
            </svg>
          </div>
          <div class="title">{{ title }}</div>
        </div>
      </header>
      <div class="content-block" v-html="content"></div>
      <div class="action-block">
        <div class="left-action">
          <slot name="left-action"></slot>
        </div>
        <div class="right-action">
          <slot name="right-action"></slot>
        </div>
      </div>
    </div>
    <BottomSheet
      :isVisible="bottomSheetVisible"
      @close="handleBottomSheetClose"
      attached
      noHeader
      drawerHeight="auto"
      v-if="modalVisible && !isScreenSizeAboveBreakpoint"
    >
      <template #content>
        <div :class="`slk-g-modal slk-mdl-v-${variant} ${type}`">
          <header>
            <div class="title-block">
              <div class="modal-icon" v-if="hasIcon">
                <svg class="icon feather">
                  <use :href="`/imgs/storybook/feather-sprite.svg#${icon}`" />
                </svg>
              </div>
              <div class="title">{{ title }}</div>
            </div>
          </header>
          <div class="content-block" v-html="content"></div>
          <div class="action-block">
            <div class="left-action">
              <slot name="left-action"></slot>
            </div>
            <div class="right-action">
              <slot name="right-action"></slot>
            </div>
          </div>
        </div>
      </template>
    </BottomSheet>
  </div>
</template>

<script>
import BottomSheet from "../bottom-sheet/bottomSheetView.vue";
export default {
  name: "modal-view",
  props: {
    variant: { type: String, defaut: "neutral" },
    type: { type: String, defaut: "vertical" },
    hasIcon: { type: Boolean, default: true },
    icon: { type: String },
    title: { type: String },
    content: { type: String },
    modalVisible: { type: Boolean },
  },
  components: { BottomSheet },
  watch: {
    modalVisible(value) {
      if (value === true) {
        this.bottomSheetVisible = true;
      }
    }
  },
  data() {
    return {
      bottomSheetVisible: false,
      isScreenSizeAboveBreakpoint: window.innerWidth > 768, // Adjust breakpoint as needed
    };
  },
  methods: {
    closeModal() {
      this.bottomSheetVisible = false;
      this.$emit("close");
    },
    handleBottomSheetClose() {
      this.bottomSheetVisible = false;
    },
    updateScreenSize() {
      this.isScreenSizeAboveBreakpoint = window.innerWidth > 768; // Adjust breakpoint as needed
    },
  },
};
</script>
